import {styled} from '@mui/material/styles'

export const SingleNewsWrapper = styled('div', {
    name: 'SingleNews',
    slot: 'Wrapper',
})(({theme}) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: theme.spacing(10, 4),

    [theme.breakpoints.up('sm')]: {
        margin: theme.spacing(24, 8),
    },

    [theme.breakpoints.up('md')]: {
        width: '60%',
        margin: '80px auto'
    },
}))

export const SingleNewsImageWrapper = styled('div', {
    name: 'SingleNews',
    slot: 'ImageWrapper',
})(({theme}) => ({
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(4),

    img: {
        width: '80%',
        maxHeight: 250,
        borderRadius: 12
    },

    [theme.breakpoints.up('sm')]: {
        img: {
            maxHeight: 450,
        },
      },
}))

export const SingleNewsDetailsWrapper = styled('div', {
    name: 'SingleNews',
    slot: 'DetailsWrapper',
})(({theme}) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '80%',
    margin: '0 auto',
    gap: theme.spacing(2),
}))


export const SingleNewsTitle = styled('h1', {
    name: 'SingleNews',
    slot: 'Title',
})(({theme}) => ({
    textAlign: 'center',
    fontWeight: 'lighter',
    marginTop: theme.spacing(6),

    [theme.breakpoints.up('sm')]: {
        fontSize: 42,
    },

    [theme.breakpoints.up('md')]: {
        fontSize: 48,
    },
}))

export const GoBackIconWrapper = styled('div', {
    name: 'SingleNews',
    slot: 'IconWrapper',
})(({theme}) => ({
    display: 'flex',
    paddingTop: 40,
    cursor: 'pointer',
    fontWeight: 'lighter',
    marginBottom: theme.spacing(2)
}))

export const GoBackText = styled('span', {
    name: 'SingleNews',
    slot: 'GoBackText',
})(() => ({
    fontSize: 16,
    fontWeight: 'lighter',
    fontStyle: 'italic'
}))